// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__2O2K9","h2":"Contact_h2__SXLOa","button":"Contact_button__1Vd_T","h1":"Contact_h1__32keB","p":"Contact_p__1sz6I"};